import { useEffect } from 'react';

import { DateTime } from 'luxon';
import { useFormContext } from 'react-hook-form';

import { convertISODateTimePartsToUTCISO } from 'src/common/date/convertISODateTimePartsToUTCISO';
import { useTripsSuggestedPickupAtCreateMutation } from 'src/common/external/bambi-api/bambiApi';

const useCalculatePickupTime = (index: number) => {
  const { watch, setValue, clearErrors } = useFormContext();
  const [calculatePickupTime] = useTripsSuggestedPickupAtCreateMutation();

  const date = watch('start_date');
  const appointmentTime = watch(`recurrences.${index}.appointment_time`);
  const pickup = watch(`pickup.address`);
  const dropoff = watch(`dropoff.address`);
  const spaceTypeEnum = watch(`service_details.space_type`) || 'wheelchair';
  const pickupTime = watch(`recurrences.${index}.pickup_time`);
  const loadTime = watch(`load_time_seconds`);
  const unloadTime = watch(`unload_time_seconds`);

  useEffect(() => {
    if (pickupTime) return;

    async function fetchSuggestedPickupTime() {
      if (date && appointmentTime && pickup?.value && dropoff?.value) {
        const appointmentDateTime = convertISODateTimePartsToUTCISO({
          date,
          time: appointmentTime,
        });

        try {
          const res = await calculatePickupTime({
            tripSuggestedPickupTime: {
              appointment_at: appointmentDateTime,
              pickup_aws_place_id: pickup.value,
              dropoff_aws_place_id: dropoff.value,
              space_type: spaceTypeEnum,
              load_time_seconds: loadTime || undefined,
              unload_time_seconds: unloadTime || undefined,
            },
          }).unwrap();

          if (res.pickup_at) {
            const time = DateTime.fromISO(res.pickup_at)
              .toLocal()
              .toFormat('HH:mm');
            setValue(`recurrences.${index}.pickup_time`, time);
            clearErrors(`recurrences.${index}.pickup_time`);
          }
        } catch (err) {
          // Optionally handle error
        }
      }
    }

    fetchSuggestedPickupTime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    date,
    appointmentTime,
    pickup.value,
    dropoff.value,
    spaceTypeEnum,
    loadTime,
    unloadTime,
    calculatePickupTime,
    index,
  ]);
};

export default useCalculatePickupTime;
